module.exports = __webpack_public_path__ + "static/media/Gayatri Patkar.e6f9f69a.png";